import React from "react";

function CustomShippingFeeNotAdded() {
  return <p className="flex justify-end my-2 text-red-500">* Shipping fee not added yet</p>;
}

export default CustomShippingFeeNotAdded;
